export const LOGIN = "LOGIN";
export const SIGNOUT = "SIGNOUT";

export const FETCH_ALL_MEMBERS = "FETCH_ALL_MEMBERS";
export const LOADING_USER = "LOADING_USER";
export const ERROR_USER = "ERROR_USER";
export const FETCH_USER = "FETCH_USER";
export const UPDATE_USER = "UPDATE_USER";

export const LOADING_BOARD = "LOADING_BOARD";
export const GET_BOARD = "FETCH_BOARD";
export const ADD_BOARD = "ADD_BOARD";
export const REMOVE_BOARD = "REMOVE_BOARD";
export const UPDATE_BOARD = "UPDATE_BOARD";

export const GET_LIST_TASK = "GET_LIST_TASK";
export const ADD_LIST_TASK = "ADD_LIST_TASK";
export const REMOVE_LIST_TASK = "REMOVE_LIST_TASK";
export const UPDATE_LIST_TASK = "UPDATE_LIST_TASK";

export const FETCH_TASK = "FETCH_TASK";
export const ADD_TASK = "ADD_TASK";
export const REMOVE_TASK = "REMOVE_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
